import React from 'react';

function Award({active}) {
  return (
    <div id="award_img" style={{ width: 40, height: 40 }}>
      <img src={!active ?  "/img/profile/award.svg" : "/img/profile/completo.svg"} alt="logro" />
      {/* <img src={"/img/profile/completo.svg"} alt="logro" /> */}
    </div>
  );
}

export default Award;
